import styled from 'styled-components'

export const BlueBoxContainer = styled.div`
  background-color: rgba(38, 127, 202, 0.8);
  border-radius: 20px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
`

export const TopTextContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
  align-items: center;

  @media only screen and (max-width: 600px) {
    flex-direction: column;
    align-items: flex-start;
  }

`
export const TopIcon = styled.img`
  margin-right: 0.5rem;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`

export const TopText1 = styled.span`
  text-transform: uppercase;
  color: rgba(255, 255, 255, 1);
  margin-right: 0.5rem;
  font-weight: 700;
`

export const TopText2 = styled.span`
  text-transform: uppercase;
  color: rgba(255, 255, 255, 1);

  @media only screen and (max-width: 767px) {
    margin-top: 8px;
    margin-bottom: 5px;
  }
`

export const EmbedContainer = styled.div`
  background-color: white;
  padding: 15px;
`

export const ErrorContainer = styled.div`
  padding: 5px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  color: red;
  font-size: 12px;
`

export const FormWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0;

  @media only screen and (max-width: 1024px) {
    flex-direction: column;
  }
`

export const FormInputFields = styled.div`
  border: 1px solid #CFD1D7;
  border-radius: 8px;
  padding: 2px;
  display: flex;
  width: 73.5%;

  @media only screen and (max-width: 1024px) {
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    flex-direction: column;
  }
`

export const FormSubmitButton = styled.input`
  margin-left: 10px;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  padding: 10px 25px;
  border-radius: 8px;
  background-color: #29A604;
  transition: all ease-in-out 0.3s;
  cursor: pointer;
  width: 25%;
  height: 60px;
  border: none;

  @media only screen and (max-width: 1024px) {
    margin-left: 0;
    width: 100%;
    margin-top: 20px;
    height: 55px;
  }
`

export const FromField = styled.div`
  width: 33%;
  position: relative;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

export const ToField = styled.div`
  width: 33%;
  position: relative;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`

export const EmailField = styled.div`
  width: 34%;
  position: relative;
  border-left: 1px solid #CFD1D7;

  @media only screen and (max-width: 600px) {
    width: 100%;
    border-left: 0;
  }
`

export const Icon1 = styled.img`
  position: absolute;
  top: 18px;
  left: 15px;
`

export const Icon2 = styled.img`
  position: absolute;
  top: 18px;
  left: 0;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`

export const Icon3 = styled.img`
  position: absolute;
  top: 18px;
  left: 40px;

  @media only screen and (max-width: 600px) {
    left: 17px;
  }
`

export const FromInput = styled.input`
  height: 60px;
  border: none !important;
  padding-left: 50px !important;
  &:focus {
    outline: none;
  }
`

export const ToInput = styled.input`
  height: 60px;
  border: none;
  padding-left: 75px !important;
  padding-right: 5px !important;
  &:focus {
    outline: none;
  }
  
  @media only screen and (max-width: 600px) {
    padding-left: 50px !important;
  }
`

export const EmailInput = styled.input`
  height: 60px !important;
  border: none !important;
  padding-left: 50px !important;
  &:focus {
    outline: none;
  }

  @media only screen and (max-width: 600px) {
    padding-left: 50px;
  }
`

export const BottomTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: .5rem;
  justify-content: space-between;
  algn-items: center;

  @media only screen and (min-width: 600px) {
    flex-direction: row;
    margin-top: 1rem;
  }
`

export const BottomLeftText = styled.p`
  color: rgba(255, 255, 255, 1);
  font-size: 13px;
  line-height: 1.25rem;
  margin: 0px;
`

export const BottomLeftLink = styled.a`
  color: rgba(255, 255, 255, 1);
  text-decoration: none;
  transition: all ease-in-out 0.2s;
  &:hover {
    color: #29A604 !important;
  }
`

export const BottomRightText = styled.p`
  font-size: 13px;
  color: rgba(255, 255, 255, 1);
  line-height: 1.25rem;
  margin: 7px 0px 0px 0px !important;
  
  @media only screen and (min-width: 640px) {
    margin-top: 0px;
  }
  
`

export const BottomRightIcon = styled.img`
  margin-right: 0.25rem;
  display: inline-block;

  @media only screen and (max-width: 600px) {
    display: none;
  }
`

export const BottomRightLink = styled.a`
  color: rgba(255, 255, 255, 1) !important;
  padding: 0.25rem 0.5rem 0.25rem 0.5rem !important;
  cursor: pointer !important;
  border-radius: 0.25rem !important;
  background-color: rgba(31, 41, 55, 1) !important;
  transition: all ease-in-out 0.2s !important;
  text-decoration: none !important;
  margin-left: 3px !important;
`